import { HttpClient, HttpParams, HttpErrorResponse, HttpEvent, HttpEventType, HttpProgressEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UploadStatus } from '../models/common.model';
import { WebFamGedcom } from '../models/gedcom.model';

@Injectable()
export class GedcomService {

    constructor(private httpClient: HttpClient) { }

    uploadGedcom(fileData: FormData) {
        return this.httpClient.post<UploadStatus>(
                    environment.backendUrl + '/gedcom/import/tree/' + environment.currentTree,
                    fileData,
                    { reportProgress: true, observe: 'events' }
                ).
                pipe(map(event => this.getEventMessage(event, fileData)),
                    catchError(this.handleError)
                );
    }

    exportGedcom() {
        return this.httpClient.get(environment.backendUrl + '/gedcom/export/tree/' + environment.currentTree);
    }

    importGedcomToNewTree(fileId: string, tree: { title: string; url: string }) {
        return this.httpClient.post<{ id: string; title: string; url: string }>(
            environment.backendUrl + '/gedcom/import-to-new-tree/tree/' + environment.currentTree + '/file/' + fileId,
            { data: tree });
    }

    downloadGedcom(fileId: string) {
        return this.httpClient.get(
            environment.backendUrl + '/gedcom/download/tree/' + environment.currentTree + '/file/' + fileId,
            { responseType: 'blob' });
    }

    removeGedcom(fileId: string) {
        return this.httpClient.delete(environment.backendUrl + '/gedcom/remove/tree/' + environment.currentTree + '/file/' + fileId);
    }

    listGedcom() {
        return this.httpClient.get<WebFamGedcom[]>(environment.backendUrl + '/gedcom/list/tree/' + environment.currentTree);
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}`);
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened. Please try again later.');
    }

    private getEventMessage(event: HttpEvent<unknown>, formData: FormData) {
        console.log(event);
        switch (event.type) {
            case HttpEventType.UploadProgress:
                return this.fileUploadProgress(event);
            case HttpEventType.Response:
                return this.apiResponse(event);
        }
        return undefined;
    }

    private fileUploadProgress(event: HttpProgressEvent) {
        const percentDone = Math.round(100 * event.loaded / (event.total ? event.total : 0));
        if (percentDone !== 100) {
            return { status: 'progress', message: percentDone };
        }
        else {
            return { status: 'done', message: percentDone };
        }
    }

    private apiResponse(event: HttpResponse<unknown>) {
        return event.body;
    }


}
